import { jUserLittleSchema } from './user';
import { jArticleListSchema, jArticleViewSchema } from './article';
import { z } from 'zod';

export const jSupportListSchema = jArticleListSchema.extend({
    supportStatus: z.union([z.number(), z.string()]).nullable(),
    supportType: z.union([z.number(), z.string()]).nullable(),
    supportOwner: z.array(jUserLittleSchema),
});
export type jSupportList = z.infer<typeof jSupportListSchema>;

export const jSupportViewSchema = jArticleViewSchema.and(jSupportListSchema).and(z.object({}));
export type jSupportView = z.infer<typeof jSupportViewSchema>;
